import user from "./user";
import narrationSummaries from "./narrationSummaries";
import book from "./book";
import Imam from "./Imam";
import subject from "./subject";
import quran from "./quran";
import narration from "./narration";
import transfer from "./transfer";
import narrationSummary from "./narrationSummary";

export default {
  Imam,
  user,
  narrationSummaries,
  narrationSummary,
  book,
  subject,
  quran,
  narration,
  transfer,
};
